export default __webpack_public_path__ + "static/media/moskolShot.cff9234b.png";